'use strict';

// gfx
import Rect from './gfx/rect';
import Vector2 from './gfx/vector2';

import Element from './gui/element';
import Canvas from './gui/canvas';
import Grid from './gui/grid';

export default {
	gfx: {
		Rect,
		Vector2
	},
	gui: {
		Element,
		Canvas,
		Grid
	}
};
